<template>
  <div id="navbarAvatar" class="eca-avatar" tabindex="-1">
    <app-avatar size="small" :picture="profilePicture" :name="name">
    </app-avatar>

    <i class="cs-icons-expand-arrow-filled"></i>
    <b-popover
      ref="profilePopover"
      target="navbarAvatar"
      placement="leftbottom"
      triggers="click blur"
      custom-class="bg-dark"
    >
      <div>
        <div class="eca-avatar__body">
          <div class="eca-avatar__wrapper">
            <div class="cs-textstyle-paragraph-small-bold eca-avatar__name">
              {{ name }}
            </div>
            <div
              v-if="email"
              class="cs-textstyle-paragraph-small eca-avatar__email"
            >
              {{ email }}
            </div>
          </div>
          <div class="eca-avatar__item" @click="logout">
            <i class="ch-icons-logout"></i>
            Log Out
          </div>
        </div>
      </div>
    </b-popover>
  </div>
</template>

<script>
import AppAvatar from '@/components/general/Avatar.vue';

export default {
  components: {
    AppAvatar,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      default: '',
    },
    profilePicture: {
      type: String,
      // TODO: add required:true and remove default
      default: '',
    },
  },
  methods: {
    closeProfilePopover() {
      this.$refs.profilePopover.$emit('close');
    },
    logout() {
      this.$refs.profilePopover.$emit('close');
      localStorage.clear();
      window.location.href = '/';
    },
  },
};
</script>

<style scoped>
.eca-avatar {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}
.eca-avatar__body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: var(--cs-gray-00);
  width: 100% !important;
}
.eca-avatar__item:hover {
  cursor: pointer;
  color: var(--cs-gray-02);
}
.eca-avatar__wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: wrap;
  text-align: center;
  border-bottom: 1px solid var(--cs-gray-05);
  padding: 0em 1em 0.5em 1em;
  margin: 0 -1em;
}
.eca-avatar__email {
  color: var(--cs-gray-03);
}
</style>
